import React from 'react';
import store from 'store';
import u from '../utilities/Utilities';
import AppLayout from '../components-app/AppLayout';
import {Databox,Segment,Step,LoadGraphic,UploadPhoto,EmptyAvatar} from '../components-static/Common';
import {Date,Select,Button, TextButton} from '../components-static/Input';
import ModuleListMap from '../data/ModuleListMap';
import {Permissions} from './PermissionGroupList';
import {Link} from 'react-router-dom';
import QRCode from 'qrcode.react';
import Measure from 'react-measure';
import "../styles/dashboard.scss";
import PropTypes from 'prop-types';
import moment from 'moment';


export default class Dashboard extends React.Component{

    state={
        action:"No Permission",
        actionLabel:"",
        latestEvents:[],
        name:u.getFullName(),
        avatar:u.getUserAvatar(),
        token:u.getTurnstileToken(),
        tokenTime:u.getTokenTime(),
        quickActions:[
            {label:"Live View",ref:"turnstiles",image:"/images/dashboard/turnstiles.png",permission:(u.getPermissions("combined").security >= 1)},
            {label:"Permissions",ref:"permissions",image:"/images/dashboard/my-permissions.png",permission:true},
            {label:"My Events",ref:"myEvents",image:"/images/dashboard/my-events.png",permission:(u.getPermissions("history").general >= 1)},
            {label:"Logout",ref:"logout",image:"/images/dashboard/logout.png",permission:true},
        ],
        quickSelected:"",
        name:u.getFullName(),
        dimensions:{
            width:1,
            height:1,
        },
        refreshCode:false,
    };

    quickAnchor=u.getKey();

    componentDidMount=(e)=>{
        const action = store.get("dashboard-action");
        const actionLabel = store.get("dashboard-action-label");
        store.remove("dashboard-action");
        store.remove("dashboard-action-label");
        this.setState({action:action,actionLabel:actionLabel});
        this.getLatestEvents();

        this.refreshCookies = setInterval(()=>{
            const diff = moment().diff(this.state.tokenTime,"days");
            if(diff > 0){
                this.validateToken();
            }
            else{
                const token = u.getTurnstileToken();
                this.setState({token:token});
            }
        },1000)
    }

    componentWillUnmount=()=>{
        clearInterval(this.refreshCookies);
    }

    getLatestEvents=()=>{
        u.post({
            url:"/api/get-latest-events",
            data:{
                tenantID:u.getTenantID(),
                userID:u.getUserID()
            },
            success:(callback)=>{
                this.setState({latestEvents:callback});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onSetupTask=(e)=>{
        const index = parseInt(e.currentTarget.id);
        const target = this.state.pendingTasks[index];
        const targetMap = ModuleListMap[target.module];
        store.set(targetMap.query,"@id("+target.id+")");
    }

    onQuickAction=(e)=>{
        const index = parseInt(e.currentTarget.id);
        const target=this.state.quickActions[index];

        if(target.ref=="logout"){
            u.logout();
            return 0;
        }

        if(target.ref=="myEvents"){
            store.set("historylist","@staff("+u.getFullName()+")");
            window.open("/history-list","_blank");
            return 0;
        }

        if(target.ref=="turnstiles"){
            window.open("/monitoring","_blank");
            return 0;
        }

        if(target.ref == this.state.quickSelected){
            this.setState({quickSelected:"none"});
        }
        else{
            this.setState({quickSelected:target.ref});
        }
    }

    onCancelQuickAction=()=>{
        this.setState({quickSelected:""});
    }

    onNewProfile=(link)=>{
        store.set("avatarLink",link);
        this.setState({avatar:link,quickSelected:"none"});
    }

    validateToken=()=>{
        this.setState({refreshCode:true});
        u.post({
            url:"/api/validate-token",
            data:{},
            success:(callback)=>{
                //Update cookies
                for(var key in callback){
                    store.set(key,callback[key]);
                }
                store.set("tokenTime",moment().format("YYYY-MM-DD"));
                this.setState({refreshCode:false,token:callback.token,tokenTime:moment().format("YYYY-MM-DD")});
            },
            error:(error)=>{}
        });
    }

    render=()=>{
        const width = Math.floor(this.state.dimensions.width);
        const logoWidth = Math.round(width * 0.25);

        return (
            <AppLayout title="Dashboard" requiredPermission="none" url="/dashboard">
                {
                    (this.state.action == "No Permission")
                        ?
                        <div style={{textAlign:"center"}} className="text-negative">You do not have permission to access {this.state.actionLabel} module</div>
                        :
                        ""
                }
                <Databox active={true} align="center" margin="0">
                    <h2 className="theme-emphasis">Welcome Back, {this.state.name}</h2>

                    <div className="dashboard-qr">
                        <Measure bounds onResize={contentRect => {this.setState({ dimensions: contentRect.bounds })}}>
                            {
                                ({measureRef})=>
                                    (
                                        <div ref={measureRef} className="dashboard-qr-image">
                                            <LoadGraphic active={this.state.refreshCode} text="Refreshing Token..."/>
                                            <QRCode value={this.state.token}
                                                    size={width}
                                                    level="Q"
                                                    imageSettings={{
                                                        src:"/images/cards/soilbuild-qr.png",
                                                        width:logoWidth,
                                                        height:logoWidth,
                                                    }}/>
                                        </div>
                                    )
                            }
                        </Measure>
                    </div>

                    <div className="pending-tasks">
                        <h3>My Latest Events</h3>
                        <div style={{width:"750px",maxWidth:"95%",margin:"auto",border:"1px solid #f4f4f4",borderRadius:"5px"}}>
                        {
                            (this.state.latestEvents.length > 0)
                                ?
                                <div>
                                    <div style={{maxHeight:"200px",overflow:"auto"}}>
                                    {
                                        this.state.latestEvents.map(
                                            (item,index)=>{
                                                const isToday = (moment().diff(item.dateTime,"days") == 0);
                                                return (
                                                    <div key={index} className="pending-task-item">
                                                        <div className="pending-task-event">
                                                            <span>{u.capitalize(item.action,true)} </span>
                                                            <span>{(item.targetLink==null) ? item.targetName : <Link to={item.targetLink} id={item.targetLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{item.targetName}</Link>}</span>
                                                            <span>{(item.targetField==null) ? "" : " (" + item.targetField + ")"}</span>
                                                            <span>{(item.from == null) ? "" : ((item.fromLink == null) ? " from "+item.from : <span> from <Link to={item.fromLink} id={item.fromLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{item.from}</Link></span>)}</span>
                                                            <span>{(item.to == null) ? "" : ((item.toLink == null) ? " to "+item.to : <span> to <Link to={item.toLink} id={item.toLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{item.to}</Link></span>)}</span>
                                                        </div>
                                                        <div className="pending-task-date">
                                                            {moment(item.dateTime).format((isToday) ? "h:mma" : "DD MMM YY")}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        )
                                    }
                                    </div>
                                </div>
                                :
                                <div className="pending-task-empty">No events performed</div>
                        }
                        </div>
                    </div>

                    <div className="quick-actions">
                        <h3>Quick Actions</h3>
                        <div>
                            {
                                this.state.quickActions.map(
                                    (item,index)=>{
                                        return (
                                            <div className="quick-action-item" key={index} id={index+""} onClick={this.onQuickAction}>
                                                <img src={item.image}/>
                                                <div>{item.label}</div>
                                            </div>
                                        )
                                    }
                                )
                            }
                        </div>
                        <div style={{width:"1280px",maxWidth:"98%",margin:"auto"}}>
                            <div className="quick-action-content" id={this.quickAnchor}>
                                <UserPermissions scrollAnchor={this.quickAnchor} active={this.state.quickSelected=="permissions"} onCancel={this.onCancelQuickAction}/>
                            </div>
                        </div>
                    </div>
                </Databox>
            </AppLayout>
        )
    }

}

class ProfilePic extends React.Component{

    componentDidUpdate=(oldProps,oldState)=>{
        this.refs["photo"].show(this.props.active);
    }

    onToggleForm=()=>{
        this.props.onCancel();
    }

    onComplete=(link)=>{
        //Commit to store, refresh page image
        this.props.onComplete(link);
    }

    render=()=>{
        return(
            <UploadPhoto scrollAnchor={this.props.scrollAnchor} ref="photo" reference="photo" id={this.id} url={"/api/commit-staff-avatar"} fieldname="avatarLink" onUpload={this.onComplete} onToggleForm={this.onToggleForm} noTitle={true}/>
        )
    }
}

class UserPermissions extends React.Component{

    state={
        content:{
            permissions:u.getAllPermissions()
        }
    };

    render(){
        return (
            <Segment active={this.props.active} align="center" scrollAnchor={this.props.scrollAnchor}>
                <h2>User Permissions</h2>
                <div style={{margin:'20px auto'}}>Permissions can only be edited from the Permission Group page</div>
                <Permissions content={this.state.content} noEdit={true} permission={false} type="slider"/>
                <div className="segment-buttons">
                    <Button type="medium" content={this.state.content} onClick={this.props.onCancel}>Close</Button>
                </div>
            </Segment>
        )
    }
}
